import { lpRequest } from '../../../../core/api/lp-request';
import { config } from '../../../../core/config/config';
import { logoutAction } from '../../../../core/redux/actions/logout-action';
import store from '../../../../core/redux/store';

/** The signed-in user in cb's `Me` shape, mapped from the backend's `{user, account, payment_settings}`. */
export const getMe = async (): Promise<any> => {
  try {
    const { user, account, payment_settings } = await lpRequest('/client/user/me');

    return {
      id: user.id,
      firstname: user.firstname,
      lastname: user.lastname,
      email: user.email,
      mobile_no: user.mobile_no,
      image: user.image,
      scopes: user.scopes || [],
      organization: {
        id: account.id,
        name: account.name,
        logo: account.logo || config.images.default_logo,
        wallet_feature: account.settings?.wallet_feature
      },
      payment_settings: payment_settings || []
    };
  } catch (err: any) {
    if (err.status === 401) {
      store.dispatch(logoutAction());
    }
    throw err;
  }
};
